import { IconChevronRight, IconHeartHandshake } from '@tabler/icons-react-native';
import { BottomSheet } from 'app/design/primitives/bottom-sheet';
import { Column, Row } from 'app/design/primitives/box';
import { Button } from 'app/design/primitives/button';
import { Text } from 'app/design/primitives/text';
import { createTheme as createDSTheme } from 'app/shopify';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
import { useTranslation } from 'react-i18next';

const theme = createDSTheme();

export function TrustInfoBottomSheet({
  open,
  onClose,
  onManage,
}: {
  open: boolean;
  onClose: () => void;
  onManage: () => void;
}) {
  const { t } = useTranslation('neighbour-profile');
  return (
    <BottomSheet open={open} onClose={onClose} containerStyle={{ borderTopLeftRadius: 24, borderTopRightRadius: 24 }}>
      <Column
        alignItems="center"
        gap="spacing.general.x4"
        paddingHorizontal="spacing.general.x6"
        paddingBottom="spacing.general.x4"
      >
        <Column
          alignItems="center"
          justifyContent="center"
          style={{ width: 64, height: 64, borderRadius: 12, backgroundColor: '#FAD4DC' }}
        >
          <IconHeartHandshake color={theme.colors['text.primary']} size={32} strokeWidth={ICON_STROKE_WIDTH} />
        </Column>
        <Text textAlign="center" variant="bodyBase">
          {t('trust.info')}
        </Text>
      </Column>
      <Column paddingHorizontal="spacing.general.x4" paddingBottom="spacing.general.x6" paddingTop="spacing.general.x4">
        <Button
          minHeight={56}
          justifyContent="center"
          onPress={() => {
            onClose();
            onManage();
          }}
          style={{ borderRadius: 1000, borderWidth: 1.5, borderColor: theme.colors['text.primary'] }}
        >
          <Row alignItems="center" justifyContent="center" gap="spacing.general.x2">
            <Text fontWeight="600" variant="bodyBase">
              {t('trust.manage')}
            </Text>
            <IconChevronRight color={theme.colors['text.primary']} size={24} strokeWidth={ICON_STROKE_WIDTH} />
          </Row>
        </Button>
      </Column>
    </BottomSheet>
  );
}
